/**
 * Course Certification Generator
 * Documentation: https://raw.githack.com/MrRio/jsPDF/master/docs/index.html
 * Quick Editor: https://raw.githack.com/MrRio/jsPDF/master/index.html
 * Font Converter: https://peckconsulting.s3.amazonaws.com/fontconverter/fontconverter.html
 */

const { jsPDF } = window.jspdf

/**
 * Custom HTML Element for user-certificates
 */
const customElement_userCertificates = class extends HTMLElement { // eslint-disable-line
  constructor () {
    super()

    this.userInfo = window.user?.userInfo
  }

  /**
   * Gets a proper type of data for certificate
   * @param {string} productArticleID : Article or Product ID
   * @param {string} type : 'product' || 'article'
   * @returns histories-resourcs || course || null
   */
  async getCertificateInfo (productArticleID, type) {
    try {
      const historyResourceResponse = await window.user.apiConnect(
        `histories-resource?shopify_${type}_id=${productArticleID}`
      ).then(res => res[0])

      const courseResponse = await window.user.apiConnect(
        `courses?shopify_product_id=${productArticleID}`
      ).then(res => res[0])

      return (
        typeof courseResponse === 'undefined' &&
        typeof historyResourceResponse === 'undefined'
      )
        ? null
        : typeof courseResponse === 'undefined' || courseResponse.status !== 'pass'
          ? historyResourceResponse
          : courseResponse
    } catch (err) {
      console.error(err)
      return null
    }
  }

  /**
   * Generates a certificate pdf for download
   * @param {string} productArticleID : product or article id
   * @param {sting} type : 'product' || 'article'
   * @param {string} title : Certificate title
   * @returns true if success, false if failed
   */
  async createCertificate (productArticleID, type, title) {
    try {
      if (!productArticleID || !type || !title) { return false }

      const certificateInfo = await this.getCertificateInfo(productArticleID, type)

      if (!certificateInfo) {
        alert('Certificate cannot be validated. Please contact support for assistance.')
        throw new Error('Certificate cannot be validated')
      }

      const doc = new jsPDF({ // eslint-disable-line
        orientation: 'landscape',
        unit: 'in',
        format: [11, 8.5]
      })

      if (typeof certificateInfo.certificate_template_image !== 'undefined') {
        doc.addImage(
          certificateInfo.certificate_template_image,
          certificateInfo.certificate_template_image.includes('.png') ? 'png' : 'jpg',
          0, 0, 11, 8.5
        )
      }

      doc.setFont('Poppins-Regular', 'normal')
      doc.setTextColor('#000')
      doc.setFontSize(10)

      doc.text(productArticleID, 3.75, 8.284, {
        align: 'left',
        maxWidth: 2,
        baseline: 'top'
      })

      doc.text(this.userInfo.id, 1.0, 8.284, {
        align: 'left',
        maxWidth: 2,
        baseline: 'top'
      })

      if (typeof certificateInfo.updatedAt !== 'undefined') {
        const [year, month, day] = certificateInfo.updatedAt
          .split('T')[0]
          .split('-')

        const completedDate = `${month}/${day}/${year}`

        doc.setFontSize(15)
        doc.text(completedDate, 3.1, 6.095, {
          align: 'left',
          maxWidth: 4,
          baseline: 'top'
        })
      }

      doc.setFont('Poppins-Black', 'normal')
      const fullName = `${this.userInfo.firstName} ${this.userInfo.lastName}`
      doc.setFontSize(fullName.length > 30 ? 25 : 42)
      doc.text(fullName, 0.24, 4.15, {
        align: 'left',
        maxWidth: 8.4,
        baseline: 'top'
      })

      doc.save(`${title.replace(/ |-/g, '_').replace(/ br_|br/g, '')}.pdf`)
      return true
    } catch (err) {
      console.error(err)
    }
  }
}

/**
 * Custom HTML Element for print-certificate-button
 */
const customElement_printCertificateButton = class extends HTMLElement { // eslint-disable-line
  constructor () {
    super()

    this.userCertificates = document.querySelector('[data-user-certificates]')
    this.button = this.querySelector('[data-print-certificate-button]')
    if (!this.userCertificates || !this.button) {
      this.remove()
      return
    }

    this.init()
  }

  init () {
    this.button.addEventListener('click', () => {
      this.userCertificates.createCertificate(
        this.dataset.productArticleId,
        this.dataset.type,
        this.dataset.title.replace('<br />', '\n')
      )
    })
  }
}

if (typeof window.customElements.get('user-certificates') === 'undefined') {
  window.customElements.define('user-certificates', customElement_userCertificates)
}

if (typeof window.customElements.get('print-certificate-button') === 'undefined') {
  window.customElements.define('print-certificate-button', customElement_printCertificateButton)
}
